import React, { Component } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";

import { toast, Toaster } from "react-hot-toast";
import socketIOClient from "socket.io-client";
import * as myConstList from "../../BaseUrl";
import WinningHistory from "../partials/transactionHistory/WinningHistory";
import MainTransctionHistory from "../partials/transactionHistory/TransctionHistory";
import RedeemHistory from "../partials/transactionHistory/RedeemHistory";
const baseUrl = myConstList.baseUrl;
const jwtToken = localStorage.getItem("jwtToken");
const callBackBaseUrl = myConstList.callBackBaseUrl;
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};
class TransactionHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      thirdPhaseConfig: "",
      currentSocketId: "",
    };
    this.state = {
      winningHistory: [],
      mainHistory: [],
      redeemeHistory: [],
    };

    this.getData = this.getData.bind(this);
  }

  getData() {
    const { user } = this.props.auth;
    axios
      .post(baseUrl + "api/winning-history", { id: user.id })
      .then((res) => {
        this.setState({
          winningHistory: res.data.data,
        });
      })
      .catch();
    axios
      .post(baseUrl + "api/main-transction-history", { id: user.id })
      .then((res) => {
        this.setState({
          mainHistory: res.data.data,
        });
      })
      .catch();
    axios
      .post(baseUrl + "api/redeeme-history", { id: user.id })
      .then((res) => {
        this.setState({
          redeemeHistory: res.data.data,
        });
      })
      .catch();
  }
  componentDidMount() {
    const socket = socketIOClient(baseUrl, { query: "jwtToken=" + jwtToken });
    var collectThis = this;
    socket.on("connect", () => {
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("config3rdphase");
      socket.on("3rdPhaseConfig", function (apiRespData) {
        // console.log("apiRespData==",apiRespData);
        if (socket.id == collectThis.state.currentSocketId) {
          collectThis.setState({
            thirdPhaseConfig: apiRespData.data[0].mainfunctionality,
          });
          // console.log("collectThis====",apiRespData.data[0].mainfunctionality);
        }
      });
    });
    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
    }
    this.getData();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.account !== undefined &&
      nextProps.account.account !== undefined &&
      nextProps.account.account.data !== undefined &&
      nextProps.account.account.data.data !== undefined &&
      nextProps.account.account.data.message !== undefined &&
      nextProps.account.account.data.success
    ) {
      toast.success(nextProps.account.account.data.message, toastStyles);
    }
    this.getData();
  }

  render() {
    return (
      <>
        <Navbar
          urlPath={false}
          symbol={false}
          thirdPhaseConfig={this.state.thirdPhaseConfig}
        />
        <Sidebar />
        <div className="container">
          <div className="in_page ">
            <h1 className="h3 white_box">Transaction History</h1>
            <ul className="nav contatcs-tab" id="crypt-tab">
              <li role="presentation">
                <a
                  // className={
                  //   this.props.match.url === "/transaction-history"
                  //     ? "active show"
                  //     : ""
                  // }
                  className={
                    this.props.match.params.type === "past" ? "active show" : ""
                  }
                  href="#tabLive"
                  data-toggle="tab"
                >
                  Winning history
                </a>
              </li>
              <li role="presentation">
                <a
                  className={
                    this.props.match.url === "/transaction-history"
                      ? "active show"
                      : ""
                  }
                  href="#tabUpcoming"
                  data-toggle="tab"
                >
                  Transaction History
                </a>
              </li>
              {this.state.thirdPhaseConfig === "on" && (
                <li role="presentation">
                  <a
                    className={
                      this.props.match.params.type === "past"
                        ? "active show"
                        : ""
                    }
                    href="#tabPast"
                    data-toggle="tab"
                  >
                    Redeem History
                  </a>
                </li>
              )}
            </ul>
            <div className="tab-content">
              <div
                className={
                  this.props.match.url === "/transaction-history"
                    ? "tab-pane contest-slider show"
                    : "tab-pane"
                }
                id="tabLive"
              >
                <WinningHistory record={this.state.winningHistory} />
              </div>
              <div
                className={
                  this.props.match.url === "/transaction-history"
                    ? "tab-pane contest-slider active show"
                    : "tab-pane"
                }
                id="tabUpcoming"
              >
                <MainTransctionHistory record={this.state.mainHistory} />
              </div>
              <div
                className={
                  this.props.match.params.type === "past"
                    ? "tab-pane active contest-slider show"
                    : "tab-pane contest-slider"
                }
                id="tabPast"
              >
                <RedeemHistory record={this.state.redeemeHistory} />
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }
}

TransactionHistory.propTypes = {
  auth: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  account: state.account,
  records: state.records,
});

export default connect(mapStateToProps)(TransactionHistory);
